<script lang="ts">import { browser } from "$app/environment";
const prodHosts = [
	"turboslot.com",
	"www.turboslot.com",
	/^tsdomain\d?\.online$/,
	/^turboslot(0|[1-9]\d{0,3})\.com$/
];
const hostname = browser ? window.location.hostname : "";
const showSeal = browser && prodHosts.some((entry) => typeof entry === "string" ? entry === hostname : entry.test(hostname));
</script>

{#if showSeal}
	<iframe
		title="Seal"
		src="/seal-turbo.htm"
		style="height: 48px; width: 48px; border: none; display: block;"
	></iframe>
{/if}
